import React from 'react';
import { Tag } from 'lucide-react';

const KeywordsDisplay = ({ keywords }) => {
  if (!keywords || keywords.length === 0) {
    return (
      <div className="backdrop-blur-sm bg-white/40 rounded-xl sm:rounded-2xl shadow-sm border border-cream-300/50 p-4 sm:p-5 md:p-6">
        <div className="flex items-center space-x-2 sm:space-x-3 mb-3 sm:mb-4">
          <Tag className="w-5 h-5 sm:w-6 sm:h-6 text-brown-400" />
          <h3 className="text-base sm:text-lg md:text-xl font-semibold text-brown-900">Keywords</h3>
        </div>
        <p className="text-xs sm:text-sm md:text-base text-brown-500">No keywords extracted</p>
      </div>
    );
  }

  return (
    <div className="backdrop-blur-sm bg-white/40 rounded-xl sm:rounded-2xl shadow-sm border border-cream-300/50 p-4 sm:p-5 md:p-6">
      
      {/* Header - Responsive */}
      <div className="flex items-center justify-between mb-4 sm:mb-5">
        <div className="flex items-center space-x-2 sm:space-x-3">
          <Tag className="w-5 h-5 sm:w-6 sm:h-6 text-brown-600" />
          <h3 className="text-base sm:text-lg md:text-xl font-semibold text-brown-900">Keywords</h3>
        </div>
        <span className="text-xs sm:text-sm text-brown-500 font-medium">
          {keywords.length} {keywords.length === 1 ? 'term' : 'terms'}
        </span>
      </div>

      {/* Keywords Grid - Responsive columns */}
      <div className="flex flex-wrap gap-2 sm:gap-2.5 md:gap-3">
        {keywords.map((keyword, index) => (
          <span 
            key={index}
            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-br from-brown-50 to-brown-100/50 text-brown-700 text-xs sm:text-sm md:text-base font-medium rounded-lg sm:rounded-xl border border-brown-200/50 hover:from-brown-100 hover:to-brown-200/50 hover:shadow-sm transition-all cursor-default"
          >
            {keyword}
          </span>
        ))}
      </div>
    </div>
  );
};

export default KeywordsDisplay;